export const RESET = 'LOG_LIST_RESET'
export const SET_ITEMS = 'LOG_LIST_SET_ITEMS'
export const SET_ERROR = 'LOG_LIST_SET_ERROR'
export const SET_VIEW = 'LOG_LIST_SET_VIEW'
export const TOGGLE_LOADING = 'LOG_LIST_TOGGLE_LOADING'
